// extracted by mini-css-extract-plugin
export default {"btn":"src-pages-CustomerDatabaseConfig-CustomerTag-Detail-Filters-Components-Clear-css-module__btn--9GQnb"};